import AddProductPopup from './AddProductPopup'

export default AddProductPopup
